module.exports = __webpack_public_path__ + "img/creme_brulee_afkolet.45e04726.jpg";